import { render, staticRenderFns } from "./postalCodeInput.vue?vue&type=template&id=d2e1f56c&"
import script from "./postalCodeInput.vue?vue&type=script&lang=js&"
export * from "./postalCodeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports